import axios from "axios";
import { MuralEntity } from "@/entities/MuralEntity.js";
import { apiRequest } from "@/services/api/apiClient.js";

const entity = new MuralEntity();
const getRHClient = () => window.API_RH || axios.create({
    baseURL: window.URL_API_BASE_RH || ""
});

export async function getMuralPosts({ page = 1, limit = 20, ...filters } = {}) {
    return apiRequest({
        client: getRHClient(),
        method: "get",
        url: entity.endpoints.list,
        params: { page, limit, ...filters }
    });
}

export async function createMuralPost({ body, anexo }) {
    const formData = new FormData();
    formData.append("body", body || "");

    if (anexo) {
        formData.append("anexo", anexo);
    }

    return apiRequest({
        client: getRHClient(),
        method: "post",
        url: entity.endpoints.create,
        body: formData
    });
}

export async function updateMuralPost({ id, body, anexo }) {
    const payload = { body };

    if (anexo !== undefined) {
        payload.anexo = anexo;
    }

    return apiRequest({
        client: getRHClient(),
        method: "put",
        url: entity.getUrl(entity.endpoints.update, { id }),
        body: payload
    });
}

export async function deleteMuralPost({ id }) {
    return apiRequest({
        client: getRHClient(),
        method: "delete",
        url: entity.getUrl(entity.endpoints.delete, { id })
    });
}
